import { fetchWrapper } from "../utils/fetch-wrapper";

const classeursService = {
  getAll,
  getAllByUser,
  getById,
  post,
  update,
  correspondanceClasseur,
  delete: _delete,
};

function getAll(
  env_client_id: any = "",
  creator_id: any = "",
  typologie_gex: any = ""
) {
  const queryParams: Record<string, any> = {};

  if (creator_id !== "") {
    queryParams.creator_id = creator_id;
  }
  if (env_client_id !== "") {
    queryParams.env_client_id = env_client_id;
  }

  if (typologie_gex !== "") {
    queryParams.typologie_gex = typologie_gex;
  }

  const queryString = Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join("&");

  return fetchWrapper.get(`classeurs/?${queryString}`);
}

function getAllByUser(user_id) {
  return fetchWrapper.get(`classeurs/user/${user_id}`);
}

function getById(id) {
  return fetchWrapper.get(`classeurs/${id}`);
}

function post(data) {
  return fetchWrapper.post("classeurs/", data);
}

function update(id, params) {
  return fetchWrapper.put(`classeurs/${id}`, params);
}

function _delete(id) {
  return fetchWrapper.delete(`classeurs/${id}`);
}

function correspondanceClasseur(data) {
  return fetchWrapper.post(`classeurs/correspondance`, data);
}

export default classeursService;
